import Newsbreaker from './Newsbreaker';
import Slider from './Slider';
import Tiles from './Tiles';

export default {
    Newsbreaker,
    Slider,
    Tile: Tiles
};
